export default "__VITE_ASSET__Cl14HIjK__"